import { render, staticRenderFns } from "./FooterLinks.vue?vue&type=template&id=6c177ccb&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FooterLinks.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Ffooter%2FFooterLinks%2FFooterLinks.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports